module.exports = __webpack_public_path__ + "static/images/green-down-arrow.3aebYC-.svg";